import Http from './http';

const prefix = '/category';

export const getCategories = () => Http.authApi().get(`${prefix}`);

export const get = ({ id }) => Http.authApi().get(`${prefix}/${id}`);

export const create = category => Http.authApi().post(`${prefix}`, category);

export const edit = category =>
  Http.authApi().put(`${prefix}/${category.id}`, category);

export const exclude = category =>
  Http.authApi().delete(`${prefix}/${category.id}`, category);



// WEBPACK FOOTER //
// ./src/js/services/category.js